var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.hasAnyPerms([
    'dashboard.view_feature_photoservice_photographers'
  ]))?_c('CSidebarNavTitle',[_vm._v(_vm._s(_vm.$gettext('My photo service')))]):_vm._e(),(_vm.hasAnyPerms(['dashboard.view_feature_photoservice_photographers']))?_c('CSidebarNavItem',{attrs:{"name":_vm.$gettext('Photographers'),"to":"/my-photo-service/photographers","icon":"cip-photographer"}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }